// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    apiRoot: 'https://pdw-stage-sp-app-service.azurewebsites.net/api',
    clientRoot: 'https://pdw-stage-sp-app-service.azurewebsites.net',
    idpAuthority: 'https://pam-stage-is4-app-service.azurewebsites.net',
    clientId: 'pdw_student_portal',
    siteKey: "6Lf3VfciAAAAAG54RCOFAflNTcq0B54oUt5c6raO", //recaptcha
    connex_host_name_en: 'pathwaysconnex',
	connex_host_name_fr: 'passeportconnex',
    googleMapsAPIKey: 'AIzaSyAAM-KYQgo3RqnqejOWPIVlL8ut2N_k6pw',
    featureList: [
        {name: 'messaging', isEnabled: true},
        {name: 'feed', isEnabled: true},
        {name: 'goals', isEnabled: true},
        {name: 'scheduling', isEnabled: false},
    ]
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
